import { lazyload } from '@/lib/lazy-load'

export const ImageDemo = lazyload(() => import('./ImageDemo').then((m) => ({ default: m.ImageDemo })))

export const SectionCardDemo2 = lazyload(() =>
  import('./SectionCardDemo2').then((m) => ({ default: m.SectionCardDemo2 }))
)
export const BarChartDemo = lazyload(() => import('./BarChartDemo').then((m) => ({ default: m.BarChartDemo })))
export const ListDemo = lazyload(() => import('./ListDemo').then((m) => ({ default: m.ListDemo })))
export const SectionCardDemo3 = lazyload(() =>
  import('./SectionCardDemo3').then((m) => ({ default: m.SectionCardDemo3 }))
)
export const LocationDemo = lazyload(() => import('./LocationDemo').then((m) => ({ default: m.LocationDemo })))
export const SectionCardJobsDemo = lazyload(() =>
  import('./SectionCardJobsDemo').then((m) => ({ default: m.SectionCardJobsDemo }))
)
export const SectionMeetingDemo = lazyload(() =>
  import('./SectionMeetingDemo').then((m) => ({ default: m.SectionMeetingDemo }))
)
export const CarouselDemo = lazyload(() => import('./CarouselDemo').then((m) => ({ default: m.CarouselDemo })))
export const CardItemsDemo = lazyload(() => import('./CardItemsDemo').then((m) => ({ default: m.CardItemsDemo })))
export const AudioDemo = lazyload(() => import('./AudioDemo').then((m) => ({ default: m.AudioDemo })))
export const VideoDemo = lazyload(() => import('./VideoDemo').then((m) => ({ default: m.VideoDemo })))
export const ButtonDemo = lazyload(() => import('./ButtonDemo').then((m) => ({ default: m.ButtonDemo })))
export const FABDemo = lazyload(() => import('./FABDemo').then((m) => ({ default: m.FABDemo })))
export const PieChartDemo = lazyload(() => import('./PieChartDemo').then((m) => ({ default: m.PieChartDemo })))
export const DatatableDemo = lazyload(() => import('./DatatableDemo').then((m) => ({ default: m.DatatableDemo })))
export const RatingProgressDemo = lazyload(() =>
  import('./RatingProgressDemo').then((m) => ({ default: m.RatingProgressDemo }))
)
export const CircleProgressDemo = lazyload(() =>
  import('./CircleProgressDemo').then((m) => ({ default: m.CircleProgressDemo }))
)
export const AccordionDemo = lazyload(() => import('./AccordionDemo').then((m) => ({ default: m.AccordionDemo })))
